export default __webpack_public_path__ + "static/media/twitter_museo.fc42032c.svg";